import { useGetAnalyticsSummary } from '@/features/analytics/analytics.queries';

/**
 * Controller hook for the Analytics dashboard page.
 */
export const useAnalyticsPage = () => {
  const { data, isLoading, isError } = useGetAnalyticsSummary();

  return {
    summary: data,
    isLoading,
    isError,
  };
};
